import { useState, type FormEvent } from "react";
import { useLogin } from "@refinedev/core";
import { Link } from "react-router-dom";
import { toast } from "sonner";

export function LoginPage() {
  const { mutate: login, isPending } = useLogin();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  function handleSubmit(e: FormEvent) {
    e.preventDefault();
    login(
      { email, password },
      {
        onError: (err) => toast.error("Error al entrar", { description: err.message }),
      },
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-bg px-4">
      <div className="w-full max-w-sm card p-8 space-y-6">
        <header className="text-center space-y-2">
          <div className="size-12 mx-auto rounded-md bg-brand grid place-items-center text-white font-bold text-xl">
            L
          </div>
          <h1 className="text-2xl font-bold">Sistema Liquidación</h1>
          <p className="text-sm text-fg-secondary">Entra para continuar</p>
        </header>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-1">
            <label htmlFor="email" className="text-sm font-medium">Correo</label>
            <input
              id="email"
              type="email"
              autoComplete="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full rounded-md border border-border bg-bg-card px-3 py-2.5 focus:outline-none focus:ring-2 focus:ring-brand"
            />
          </div>
          <div className="space-y-1">
            <label htmlFor="password" className="text-sm font-medium">Contraseña</label>
            <input
              id="password"
              type="password"
              autoComplete="current-password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full rounded-md border border-border bg-bg-card px-3 py-2.5 focus:outline-none focus:ring-2 focus:ring-brand"
            />
          </div>
          <button type="submit" disabled={isPending} className="btn-primary w-full">
            {isPending ? "Entrando..." : "Entrar"}
          </button>
        </form>

        <p className="text-center text-sm">
          <Link to="/auth/recovery" className="text-brand hover:underline">
            Olvidé mi contraseña
          </Link>
        </p>
      </div>
    </div>
  );
}
